<template>
    <div class="container main-container error-page-wrapper">
        <div
            class="error-logo"
            :class="{'error-logo--dark': userStore.theme === 'dark'}"
        >
            <FourIcon
                width="49"
                height="65"
            />
            <img
                class="error-cat"
                src="../../../images/cat.gif"
                alt="cat"
            >
            <FourIcon
                width="49"
                height="65"
            />
        </div>
        <h1 class="error-title">
            Page not found
        </h1>
        <p class="error-text">
            Sorry, the page you are looking for doesn’t exist or has been moved.
            Here are some helpful links:
        </p>

        <div class="error-action">
            <Button
                variant="light"
                size="md"
                @click="router.back"
            >
                <BackIcon />
                <span>Go back</span>
            </Button>
            <Button
                variant="dark"
                :to="toHome"
                size="md"
                active-class="active-test-me-class"
            >
                Take me home
            </Button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { type RouteLocationNamedRaw, useRouter } from 'vue-router';
import { useUserStore } from '@/vue/stores/user';
import ROUTE_NAMES from '../../routes/routeNames';
import Button from '../../components/Elements/Button.vue';
import BackIcon from '../../../images/chevron-left.svg?component';
import FourIcon from '../../../images/404.svg?component';

const userStore = useUserStore();

const router = useRouter();

const toHome = computed<RouteLocationNamedRaw>(() => {
    if (userStore.isUserLoggedIn) {
        return { name: ROUTE_NAMES.HOME };
    } else {
        return { name: ROUTE_NAMES.LOGIN_MAIN };
    }
});
</script>

<style lang="scss" scoped>
@use '@/styles/abstracts/variables';
@use '@/styles/abstracts/spacings';
@use '@/styles/abstracts/font-sizes';

.error-page-wrapper {
    display: flex;

    flex-direction: column;

    justify-content: center;

    max-width: 30rem;

    padding: spacings.$spacing-xxl-5;

    margin: auto;

    text-align: center;

    background-color: var(--theme-color-surface-primary-default);

    border-radius: variables.$border-radius-xl;
}

.error-action {
    display: flex;

    gap: spacings.$spacing-s;

    justify-content: center;
}

.error-logo {
    display: flex;

    align-items: center;

    width: max-content;
    height: 5.25rem;

    margin: 0 auto;

    svg {
        width: 100%;

        fill: var(--theme-color-text-always-black);
    }

    .error-cat {
        max-width: 6.25rem;
    }

    &--dark {
        padding: spacings.$spacing-xxs spacings.$spacing-l;

        background-color: var(--theme-color-surface-always-white);
        border-radius: 100px;
    }
}

.error-text {
    margin-bottom: spacings.$spacing-xxl-2;

    font-size: font-sizes.$font-size-m;

    color: var(--theme-color-text-secondary);
}

.error-title {
    margin-top: spacings.$spacing-xxl-2;
    margin-bottom: spacings.$spacing-m;
}

.logo-text {
    font-size: 100px;
    font-weight: bold;
    line-height: 84px;
    letter-spacing: 10px;
}
</style>
